export default "__VITE_ASSET__DopPEyrz__"